import { withStyles } from 'vopay';
import styles from './InterestAccountBanner.module.scss';
import { Skeleton, BodyText } from 'UI';

const cn = withStyles(styles);

export default function InterestDisplaySkeleton() {
  return (
    <>
      <BodyText
        style={{
          width: '100%',
        }}
      >
        <Skeleton />
      </BodyText>

      <div
        className={cn('interestRate')}
        style={{
          width: '40%',
          display: 'block',
        }}
      >
        <Skeleton width="100%" height="100%" />
      </div>
    </>
  );
}
